import React from "react";
import ImportAddress from "./Loadable";
import { NewAddressWrapper } from "wrapper/NewAddressWrapper";

export const ImportAddressPage = () => {
  return (
    <NewAddressWrapper>
      <ImportAddress />
    </NewAddressWrapper>
  );
};
